import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeNavbar from './HomeNavbar';
import './Home.css';

import { storage } from '../firebase';
import { ref, getDownloadURL } from 'firebase/storage';

const Home = () => {
  const navigate = useNavigate();
  const [bgImage, setBgImage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const bgRef = ref(storage, "backgrounds/pic1.jpg");

    getDownloadURL(bgRef)
      .then((url) => {
        setBgImage(url);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading background:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="loading-state">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div
      className="home-page"
      style={{
        backgroundImage: bgImage ? `url(${bgImage})` : "linear-gradient(45deg, #000000, #1a1a1a)",
      }}
    >
      <div className="hero-section">
        <h1>Dilan Munasingha</h1>
        <p className="tagline">Photography</p>
        <p className="description">
          Capturing timeless moments - from fashion to weddings, every shot tells a story.
        </p>
        <button
          className="view-work-btn"
          onClick={() => navigate('/portfolio')}
        >
          View My Work
        </button>
      </div>
    </div>
  );
};

export default Home;